import { POS_PIN_MAX_LENGTH, POS_PIN_MIN_LENGTH } from "./enums.js";
export const POS_PIN_REJECTION_MESSAGES = {
    LENGTH: `PIN ${POS_PIN_MIN_LENGTH}–${POS_PIN_MAX_LENGTH} rakam olmalıdır`,
    NOT_DIGITS: "PIN yalnızca rakamlardan oluşmalıdır",
    REPEATED: "PIN aynı rakamın tekrarı olamaz (ör. 1111)",
    SEQUENTIAL: "PIN ardışık rakamlardan oluşamaz (ör. 1234, 4321)",
    COMMON: "Bu PIN çok yaygın; başka bir PIN seçin",
};
/** Tuş takımında düz çizgi / sık kullanılan kalıplar. */
const COMMON_PINS = new Set(["1212", "1122", "2580", "1379", "1004", "0852", "2020", "1453", "1907", "1903"]);
/** Politikaya uymayan PIN'in gerekçesi; uygunsa `null`. */
export function posPinRejection(pin) {
    if (!/^\d+$/.test(pin))
        return "NOT_DIGITS";
    if (pin.length < POS_PIN_MIN_LENGTH || pin.length > POS_PIN_MAX_LENGTH)
        return "LENGTH";
    if (new Set(pin).size === 1)
        return "REPEATED";
    if (isSequential(pin))
        return "SEQUENTIAL";
    if (COMMON_PINS.has(pin))
        return "COMMON";
    return null;
}
export function isAcceptablePosPin(pin) {
    return posPinRejection(pin) === null;
}
/** Ardışık artan (1234) ya da azalan (4321); 10'dan 0'a sarma ardışık SAYILMAZ (ör. 9012 geçerlidir). */
function isSequential(pin) {
    const digits = [...pin].map((character) => Number(character));
    const step = (digits[1] ?? 0) - (digits[0] ?? 0);
    if (step !== 1 && step !== -1)
        return false;
    return digits.every((digit, index) => index === 0 || digit - digits[index - 1] === step);
}
//# sourceMappingURL=pin.js.map